import Icon from '@/components/ui/AppIcon';

interface Resource {
  id: number;
  title: string;
  description: string;
  icon: string;
  fileSize: string;
  format: string;
}

interface DownloadableResourcesProps {
  resources: Resource[];
}

export default function DownloadableResources({ resources }: DownloadableResourcesProps) {
  return (
    <section className="py-20 px-4 lg:px-8 bg-muted/30">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl lg:text-4xl font-heading font-bold text-foreground mb-4">
            Free Trading Resources
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Download our comprehensive guides and checklists to accelerate your trading journey.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {resources.map((resource) => (
            <div
              key={resource.id}
              className="bg-card rounded-lg border border-border p-6 hover:shadow-lg dark:hover:shadow-cyan-glow/20 transition-all duration-200"
            >
              <div className="w-16 h-16 bg-primary/10 dark:bg-primary/20 rounded-lg flex items-center justify-center mb-4">
                <Icon name={resource.icon as any} size={32} className="text-primary" />
              </div>
              
              <h3 className="text-xl font-heading font-semibold text-foreground mb-2">
                {resource.title}
              </h3>
              
              <p className="text-muted-foreground mb-4">
                {resource.description}
              </p>
              
              <div className="flex items-center justify-between mb-4">
                <span className="text-sm text-muted-foreground">{resource.format}</span>
                <span className="text-sm text-muted-foreground">{resource.fileSize}</span>
              </div>
              
              <button className="w-full flex items-center justify-center space-x-2 px-4 py-3 bg-primary text-primary-foreground font-heading font-semibold rounded-md hover:scale-105 hover:shadow-cyan-glow dark:hover:shadow-cyan-glow transition-all duration-200">
                <Icon name="ArrowDownTrayIcon" size={20} />
                <span>Download Free</span>
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}